import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { WindowService } from '../../../../common/angular-shared/services/window/window.service';

@Injectable()
export class AuthenticationResolver implements Resolve<void> {
  constructor(protected windowService: WindowService) {}

  async resolve(): Promise<void> {
    await this.windowService.nativeWindow.controller.resolveAuth0Data();
  }
}
